import React from "react";
import useApi from "@/hooks/useApi";
import useToastAlert from "@/hooks/useToastAlert";
import AIIndexes from "./AIIndexes";
import AIChatbotSettingsTabs from "./AIChatbotSettingsTabs";
import AIChatbotTrainingSettingsTabs from "./AIChatbotTrainingSettingsTab";

export default function AIChatbotTrainingIndex() {
  const api = useApi();
  const toastAlert = useToastAlert();

  return (
    <div>
      <AIChatbotTrainingSettingsTabs selectedTab={"Index"} />
      <AIIndexes />
    </div>
  );
}
